import { AppRouterConstants } from '../components/appRouter/AppRouter.constants'
import { FederatedClaims, GetUserTypeData } from '../features/login/store/login.types'
import Logger from '../services/logger.service'

export const buildOktaConfig = (userTypeData: GetUserTypeData | null) => {
  const baseUrl = userTypeData?.ssoBaseUrl
  const clientId = userTypeData?.ssoClientId
  const oktaAuthorizationServer = userTypeData?.ssoAuthorizationServer

  const oktaConfig = {
    oktaDomain: `${baseUrl}`,
    clientId: `${clientId}`,
    issuer: `${baseUrl}/oauth2/${oktaAuthorizationServer}`,
    redirectUri: `${window.location.origin}${AppRouterConstants.LOGIN_CALLBACK_ROUTE}`,
  }
  return oktaConfig
}

export const decodeAccessToken = (accessToken: string) => {
  try {
    const payload = accessToken.split('.')[1]
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))

    const federatedClaims = JSON.parse(decoded) as FederatedClaims
    federatedClaims.sub = federatedClaims.sub.toLowerCase()

    return federatedClaims
  } catch (err) {
    Logger.errorObj('Error: Invalid JWT', err)
    return null
  }
}
